export const CONTEXT_PATH = '';
export const URL_ROOT_PATH = 'http://azkho.com' + CONTEXT_PATH;
//export const CONTEXT_PATH = '/madina';
//export const URL_ROOT_PATH = 'http://localhost:8080' + CONTEXT_PATH;

export const URL_AUTH_GOOGLE =  'https://accounts.google.com/o/oauth2/auth?scope=openid%20profile%20email';
export const CLIENT_ID = '&client_id=185553894452-1ktaj0mdn70r35m8c8bp00fi0b13duc7.apps.googleusercontent.com&approval_prompt=force';
